export default "__VITE_ASSET__f911d5ae__"